export const styles = theme => ({
  card: {
    boxSizing: 'border-box',
    backgroundColor: '#FFFFFF',
    height: '296px'
  },
  cardContent: {
    maxHeight: '230px',
    '& > h3': {
      fontSize: '1.4rem'
    },
    '& > p': {
      fontSize: '0.8rem'
    }
  },
  cardActions: {
    justifyContent: 'space-around',
    height: '64px'
  },
  icon: {
    minWidth: 0
  }
});
